// FollowList.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const FollowList = ({ users, onClose, title, relays }) => {
  const [userMetadata, setUserMetadata] = useState({});

  useEffect(() => {
	const fetchUserMetadata = async () => {
	  const metadata = {};

	  for (const pubkey of users) {
		// Check cache first
		const cachedData = localStorage.getItem(`user-${pubkey}`);
		if (cachedData) {
		  const parsed = JSON.parse(cachedData);
		  if (Date.now() - parsed.timestamp < 3600000) {
			metadata[pubkey] = parsed.data;
			continue;
		  }
		}

		// Fetch from relays if not cached
		for (const relay of relays) {
		  const ws = new WebSocket(relay);
		  
		  try {
			await new Promise((resolve) => {
			  const timeout = setTimeout(() => {
				ws.close();
				resolve();
			  }, 5000);

			  ws.onopen = () => {
				ws.send(JSON.stringify([
				  "REQ",
				  "metadata",
				  {
					kinds: [0],
					authors: [pubkey],
					limit: 1
				  }
				]));
			  };

			  ws.onmessage = (event) => {
				try {
				  const [type, , data] = JSON.parse(event.data);
				  if (type === "EVENT" && data.kind === 0) {
					const userMeta = JSON.parse(data.content);
					metadata[pubkey] = userMeta;
					localStorage.setItem(`user-${pubkey}`, JSON.stringify({
					  data: userMeta,
					  timestamp: Date.now()
					}));
					clearTimeout(timeout);
					ws.close();
					resolve();
				  }
				} catch (e) {
				  console.error('Failed to parse metadata:', e);
				}
			  };
			});
			break; // Break after successful fetch
		  } catch (error) {
			console.error('Failed to fetch metadata from relay:', error);
		  }
		}
	  }

	  setUserMetadata(metadata);
	};

	fetchUserMetadata();
  }, [users, relays]);

  return (
	<div className="modal-overlay" onClick={onClose}>
	  <div className="modal-content" onClick={e => e.stopPropagation()}>
		<button className="close-button" onClick={onClose}>×</button>
		<h2>{title}</h2>
		<div className="user-list">
		  {users.map(pubkey => {
			const user = userMetadata[pubkey] || {};
			const displayName = user.name || user.display_name || 
			  `${pubkey.slice(0, 8)}...${pubkey.slice(-8)}`;

			return (
			  <Link 
				key={pubkey} 
				to={`/user/${pubkey}`}
				className="user-list-item"
			  >
				{user.picture && (
				  <img 
					src={user.picture} 
					alt=""
					className="user-avatar"
					onError={(e) => e.target.style.display = 'none'}
				  />
				)}
				<div className="user-info">
				  <span className="user-name">{displayName}</span>
				  {user.nip05 && (
					<span className="user-nip05">{user.nip05}</span>
				  )}
				</div>
			  </Link>
			);
		  })}
		</div>
	  </div>
	</div>
  );
};

export default FollowList;